import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined';
import { Box, Typography } from '@mui/material';
import defaultErrorMessage from 'src/hooks/snackbar/defaultErrorMessage';
import { useSnackbar } from 'src/hooks/snackbar/useSnackbar';
import { getErrorMessage, isClientError, isErrorResponse } from 'src/utils/api/error-utils';

interface ChangesSnackbarOptions {
    showCubeTimer?: boolean;
    successMessage?: string;
}

export const useChangesSnackbar = () => {
    const showDefaultSnackbar = useSnackbar();

    const showSnackbar = (
        error?: unknown,
        { successMessage = 'Changes have been saved' }: ChangesSnackbarOptions = {}
    ): void => {
        let apiErrorMessage = '';
        if (isClientError(error)) {
            if (isErrorResponse(error.body) && typeof error.body.message === 'string') {
                apiErrorMessage = error.body.message.trim();
            } else {
                apiErrorMessage = getErrorMessage(error, '');
            }
        }
        const errorMessage = apiErrorMessage ? (
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.25, maxWidth: 440, py: 0.5 }}>
                <ErrorOutlineOutlined sx={{ fontSize: 20, mt: 0.125, flexShrink: 0 }} />
                <Box sx={{ minWidth: 0, flex: 1, overflowWrap: 'anywhere' }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1.5 }}>
                        {defaultErrorMessage}
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1, lineHeight: 1.5 }}>
                        {apiErrorMessage}
                    </Typography>
                </Box>
            </Box>
        ) : (
            defaultErrorMessage
        );
        showDefaultSnackbar(error ? errorMessage : successMessage, {
            autoHideDuration: 7000,
            variant: error ? 'error' : 'success',
            hideIconVariant: !!apiErrorMessage,
            preventDuplicate: false,
        });
    };

    return showSnackbar;
};
